/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/extensions */
import React from 'react';
import {
  FaBoxArchive, FaBan, FaBriefcase, FaSquareCaretRight,
  FaClock, FaCodeBranch, FaGears, FaDatabase,
  FaTriangleExclamation, FaEye, FaFire, FaFireFlameCurved,
  FaHandSparkles, FaHandshake, FaHeadset, FaClockRotateLeft, FaInfinity,
  FaWandMagicSparkles, FaEnvelopesBulk,
  FaSuitcaseMedical, FaPercent, FaImagePortrait, FaQuoteLeft,
  FaSuitcase, FaTag, FaUserGroup, FaUsers, FaVideo, FaQuestion,
  FaChartSimple, FaListCheck, FaScrewdriverWrench,
} from 'react-icons/fa6';
import { Col, Navbar, } from 'react-bootstrap';
import { auth } from '@/services/auth';
import { profile } from '@/helpers/index';
import NavbarCrm from '@/components/menus/navbar-crm';
import DropdownProfile from '@/components/menus/dropdown-profile';

export default function MenusCrmComponent({ code }) {
  const user = auth.store.logged.get();
  const main = [
    {
      href: '/crm/mix',
      code: 'mix',
      icon: <FaHandSparkles />,
      label: 'MIX',
    },
  ];
  if (profile.isManager(user)) {
    main.push({
      href: '/crm/mix-monitoramento',
      code: 'monitorMix',
      icon: <FaChartSimple />,
      label: 'MIX - Monitoramento',
    });
    main.push({
      href: '/crm/mix-gerenciamento',
      code: 'managerMix',
      icon: <FaListCheck />,
      label: 'MIX - Gerencimento',
    });
  }
  if (profile.isAdmin(user)) {
    main.push({
      href: '/crm/mix-administracao',
      code: 'adminMix',
      icon: <FaScrewdriverWrench />,
      label: 'MIX - Administração',
    });
  }
  const manager = [
    {
      href: '/crm/usuarios',
      code: 'users',
      icon: <FaUsers />,
      label: 'Usuários',
    },
    {
      href: '/crm/historico-utilizacao',
      code: 'history',
      icon: <FaBoxArchive />,
      label: 'Histórico de Utilização',
    },
  ];
  const admin = [];
  if (user) {
    if (profile.canManager(user)) {
      manager.push({
        href: '/crm/fluxos-whatsapp',
        code: 'flows',
        icon: <FaCodeBranch />,
        label: 'Fluxos WhatsApp',
      });
      manager.push({
        href: '/crm/vendas',
        code: 'orders',
        icon: <FaTag />,
        label: 'Faturamento',
      });
      manager.push({
        href: '/crm/prospeccoes',
        code: 'prospects',
        icon: <FaFireFlameCurved />,
        label: 'Prospecções',
      });
      manager.push({
        href: '/crm/cadastrar-parceiro',
        code: 'partner',
        icon: <FaHandshake />,
        label: 'Cadastrar Parceiro',
      });
    }
    if (profile.isManager(user)) {
      manager.push({
        href: '/crm/servicos',
        code: 'inquiries',
        icon: <FaBriefcase />,
        label: 'Serviços Realizados',
      });
      manager.push({
        href: '/crm/pendencias',
        code: 'issues',
        icon: <FaTriangleExclamation />,
        label: 'Pendências',
      });
      manager.push({
        href: '/crm/cupons',
        code: 'coupons',
        icon: <FaPercent />,
        label: 'Cupons',
      });
      manager.push({
        href: '/crm/templates',
        code: 'templates',
        icon: <FaEnvelopesBulk />,
        label: 'Templates',
      });
      manager.push({
        href: '/crm/campanhas',
        code: 'campaigns',
        icon: <FaFire />,
        label: 'Campanhas',
      });
      manager.push({
        href: '/crm/blacklist',
        code: 'blacklist',
        icon: <FaBan />,
        label: 'Blacklist',
      });
      manager.push({
        href: '/crm/depoimentos',
        code: 'testimonials',
        icon: <FaQuoteLeft />,
        label: 'Depoimentos',
      });
      manager.push({
        href: '/crm/videos',
        code: 'videos',
        icon: <FaVideo />,
        label: 'Vídeos',
      });
    }
    if (profile.isAdmin(user)) {
      admin.push({
        href: '/crm/templates-relatorio',
        code: 'reportRemplates',
        icon: <FaWandMagicSparkles />,
        label: 'Templates de Relatório',
      });
      admin.push({
        href: '/crm/fornecedores',
        code: 'vendors',
        icon: <FaInfinity />,
        label: 'Fornecedores',
      });
      admin.push({
        href: '/crm/produtos',
        code: 'products',
        icon: <FaSuitcase />,
        label: 'Produtos',
      });
      admin.push({
        href: '/crm/slides',
        code: 'slides',
        icon: <FaSquareCaretRight />,
        label: 'Slides',
      });
      admin.push({
        href: '/crm/categorias-usuario',
        code: 'userCategories',
        icon: <FaImagePortrait />,
        label: 'Categorias de Usuário',
      });
      admin.push({
        href: '/crm/tipos-usuario',
        code: 'userTypes',
        icon: <FaUserGroup />,
        label: 'Tipos de Usuário',
      });
      admin.push({
        href: '/crm/categorias-suporte',
        code: 'supportCategories',
        icon: <FaHeadset />,
        label: 'Categorias de Suporte',
      });
      admin.push({
        href: '/crm/tipos-suporte',
        code: 'supportTypes',
        icon: <FaSuitcaseMedical />,
        label: 'Tipos de Suporte',
      });
      admin.push({
        href: '/crm/logs',
        code: 'logs',
        icon: <FaClockRotateLeft />,
        label: 'Logs',
      });
      admin.push({
        href: '/crm/auditoria',
        code: 'audit',
        icon: <FaDatabase />,
        label: 'Auditoria',
      });
      admin.push({
        href: '/crm/tarefas-agendadas',
        code: 'scheduledTasks',
        icon: <FaClock />,
        label: 'Tarefas Agendadas',
      });
      admin.push({
        href: '/crm/monitoramento',
        code: 'monitors',
        icon: <FaEye />,
        label: 'Monitoramento',
      });
      admin.push({
        href: '/crm/configuracoes',
        code: 'configurations',
        icon: <FaGears />,
        label: 'Configurações',
      });
      admin.push({
        href: '/crm/ajuda',
        code: 'helps',
        icon: <FaQuestion />,
        label: 'Ajuda',
      });
    }
  }
  return (
    <>
      <Navbar.Toggle aria-controls="basic-navbar-nav" className="not-printable pe-0" />
      <NavbarCrm code={code} menus={{ main, manager, admin, }} />
      <Navbar.Collapse className="justify-content-end">
        {user && <div className="desktop-cart not-printable"><DropdownProfile ignoreBalance align="end" /></div>}
      </Navbar.Collapse>
      <Col xs={12} className="mobile-cart not-printable text-center">
        {user && <DropdownProfile ignoreBalance align="start" />}
      </Col>
    </>
  );
}
